import { Component, OnInit , OnDestroy, ViewChild, ElementRef, HostListener, Renderer2} from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { PoloHelper } from '@app/_shared/_helpers/polo.helper';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
declare var $;

import * as _ from "underscore"
@Component({
  selector: 'layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss']
})
export class LayoutHeaderComponent implements OnInit, OnDestroy {

  searchVisible: boolean = false;
  subscriptions: any = [];
  currentUser: user;
  @ViewChild('headerc') header: ElementRef;
  headerCurrentClasses;
  dropdownOpen: boolean = false;
  isMobile: boolean = typeof window !== 'undefined' ? window.innerWidth < 992 : false;

  constructor(
    public authenticationService: AuthenticationService,
    public poloHelper: PoloHelper,
    public globalHelper: GlobalHelper,
    private renderer: Renderer2) {
    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe(
        (x) => (this.currentUser = x)
      )
    );
  }
  ngOnDestroy() {
      _.each(this.subscriptions, (sub) => sub.unsubscribe());
    }

    ngAfterViewInit() {

    //  this.poloHelper.Settings.isMobile = Events.browser.isMobile,
    // console.log(
    //   'this.header.nativeElement.classList.contains("submenu-light")',
    //   this.header.nativeElement.classList.contains('submenu-light')
    // );
    (this.poloHelper.Settings.submenuLight =
      this.header.nativeElement.classList.contains('submenu-light') == true
        ? true
        : false),
      (this.poloHelper.Settings.headerHasDarkClass =
        this.header.nativeElement.classList.contains('dark') == true
          ? true
          : false),
      (this.headerCurrentClasses = _.clone(
        this.header.nativeElement.classList
      ));
    // console.log('classlist', this.header.nativeElement.classList);

    }
    @HostListener('window:scroll',['$event'])
    onWindowScroll(event:any){
      // console.log('on scroll event');
      // this.poloHelper.documentScrollFunctions();
      this.stickyHeader();
    }
    @HostListener('window:resize', ['$event']) // for window scroll events
    onResize(event) {
      console.log('on resize event');
      this.isMobile = window.innerWidth < 992;
      if (!this.isMobile) {
        this.dropdownOpen = false;
      }
      this.poloHelper.documentResizeFunctions();
      this.stickyHeader();
    }

  ngOnInit(): void {
    this.poloHelper.documentReadyFunctions();
  }
  stickyHeader() {
    let $headerOffsetTop = this.header.nativeElement.offsetTop;

    var shrinkHeader =
        this.header.nativeElement.getAttribute('data-shrink') || 0,
      shrinkHeaderActive =
        this.header.nativeElement.getAttribute('data-sticky-active') || 200,
      scrollOnTop = $(window).scrollTop();

    if (this.header.nativeElement.classList.contains('header-modern')) {
      shrinkHeader = 300;
    }
    // console.log('scrollOnTop', scrollOnTop);
    // console.log('headerOffsetTop', $headerOffsetTop);
    // console.log('shrinkHeader', shrinkHeader);
    // console.log('this.header', typeof this.header);
    $(window).breakpoints('greaterEqualTo', 'lg', () => {
      if (
        !this.header.nativeElement.classList.contains('header-disable-fixed')
      ) {
        if (scrollOnTop > $headerOffsetTop + shrinkHeader) {
          // console.log('1');
          this.header.nativeElement.classList.add('header-sticky');
          if (scrollOnTop > $headerOffsetTop + shrinkHeaderActive) {
            // console.log('2');
            this.header.nativeElement.classList.add('sticky-active');
            if (
              this.poloHelper.Settings.submenuLight &&
              this.poloHelper.Settings.headerHasDarkClass
            ) {
              // console.log('3');
              this.header.nativeElement.classList.remove('dark');
              this.poloHelper.Settings.headerDarkClassRemoved = true;
            }
            // INSPIRO.header.logoStatus();
          }
        } else {
          console.log('4');
          console.log('this.headerCurrentClasses', this.headerCurrentClasses);
          _.each(this.header.nativeElement.classList, (c) =>
            this.header.nativeElement.classList.remove(c)
          ); // remove all
          _.each(this.headerCurrentClasses, (c) =>
            this.header.nativeElement.classList.add(c)
          ); // add origin
          // this.header.nativeElement.classList.remove(this.headerCurrentClasses);
          if (
            this.poloHelper.Settings.sliderDarkClass &&
            this.poloHelper.Settings.headerHasDarkClass
          ) {
            console.log('5');
            this.header.nativeElement.classList.remove('dark');
            this.poloHelper.Settings.headerDarkClassRemoved = true;
          }
          // INSPIRO.header.logoStatus();
        }
      }
    });
    $(window).breakpoints('lessThan', 'lg', () => {
      if (
        this.header.nativeElement.getAttribute('data-responsive-fixed') ==
        'true'
      ) {
        if (scrollOnTop > $headerOffsetTop + shrinkHeader) {
          this.header.nativeElement.classList.add('header-sticky');
          if (scrollOnTop > $headerOffsetTop + shrinkHeaderActive) {
            this.header.nativeElement.classList.add('sticky-active');
            if (this.poloHelper.Settings.submenuLight) {
              this.header.nativeElement.classList.remove('dark');
              this.poloHelper.Settings.headerDarkClassRemoved = true;
            }
            // INSPIRO.header.logoStatus();
          }
        } else {
          _.each(this.header.nativeElement.classList, (c) =>
            this.header.nativeElement.classList.remove(c)
          ); // remove all
          _.each(this.headerCurrentClasses, (c) =>
            this.header.nativeElement.classList.add(c)
          ); // add origin

          if (
            this.poloHelper.Settings.headerDarkClassRemoved == true &&
            $('body').nativeElement.classList.contains('mainMenu-open')
          ) {
            this.header.nativeElement.classList.remove('dark');
          }
          // INSPIRO.header.logoStatus();
        }
      }
    });
  }

  toggleSearch() {
    this.searchVisible = !this.searchVisible;
  }

  toggleDropdown(event: Event) {
    if (this.isMobile) {
      event.preventDefault();
      event.stopPropagation();
      this.dropdownOpen = !this.dropdownOpen;
    }
  }

  closeMenu() {
    this.dropdownOpen = false;
    // Fermer le menu mobile POLO : retirer les classes sur body, trigger et mainMenu
    this.renderer.removeClass(document.body, 'mainMenu-open');
    const trigger = document.querySelector('#mainMenu-trigger button');
    if (trigger) {
      this.renderer.removeClass(trigger, 'toggle-active');
    }
    const mainMenu = document.getElementById('mainMenu');
    if (mainMenu) {
      this.renderer.removeClass(mainMenu, 'menu-animate');
      this.renderer.setStyle(mainMenu, 'min-height', '0px');
    }
  }
}
